/*
 * Copyright (c) Harness Inc.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'

import { Color } from '@harnessio/design-system'
import { Container } from '../Container/Container'
import { Icon } from '@harnessio/icons'
import { Text } from '../Text/Text'

export const handleZeroOrInfinityTrend = (trend: string | undefined, intentColor: Color): JSX.Element => {
  const trendChange = trend ? parseInt(trend) : 0
  return isNaN(trendChange) ? ( // handling Infinity and other unexpected trends
    <Container flex={{ alignItems: 'center' }}>
      <Icon name={'caret-up'} color={intentColor}></Icon>
      <Text font="xsmall" color={intentColor}>
        N/A
      </Text>
    </Container>
  ) : (
    // handing 0 trend change
    <Container flex>{renderTrend(trend, Color.GREY_300)}</Container>
  )
}

export const renderTrend = (trend: string | undefined, intentColor: Color): JSX.Element => {
  const trendChange = trend ? parseInt(trend) : 0
  return (
    <>
      <Icon
        name={trendChange === 0 ? 'caret-right' : trendChange < 0 ? 'caret-down' : 'caret-up'}
        color={intentColor}></Icon>
      <Text font="xsmall" color={intentColor}>
        {Math.sign(trendChange) === -1 ? trend?.substring(1) : trend}
      </Text>
    </>
  )
}
